
















































































import {
  computed,
  defineComponent,
  ref,
  ssrRef,
  useFetch,
} from '@nuxtjs/composition-api';
import { SfSelect } from '@storefront-ui/vue';

import { useFacet, useUiHelpers, useUiState } from '~/composables';
import type { Pagination } from '~/composables/types';
import { useAddToCart } from '~/helpers/cart/addToCart';
import CategoryNavbar from '~/modules/catalog/category/components/navbar/CategoryNavbar.vue';
import CategoryPagination from '~/modules/catalog/category/components/pagination/CategoryPagination.vue';
import type { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import facetGetters from '~/modules/catalog/category/getters/facetGetters';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import type { Product } from '~/modules/catalog/product/types';
import type { Aggregation, ProductInterface } from '~/modules/GraphQL/types';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'CategoryPage',
  components: {
    CategoryPagination,
    CategoryEmptyResults: () =>
      import('~/modules/catalog/category/components/CategoryEmptyResults.vue'),
    CategoryFilters: () =>
      import(
        '~/modules/catalog/category/components/filters/CategoryFilters.vue'
      ),
    // CmsContent: () => import('~/modules/catalog/category/components/cms/CmsContent.vue'),
    CategoryProductGrid: () =>
      import(
        '~/modules/catalog/category/components/views/CategoryProductGrid.vue'
      ),
    CategoryNavbar,
    SfSelect,
  },
  transition: 'fade',
  setup() {
    const { routeData } = usePageStore();
    const uiHelpers = useUiHelpers();
    const isShowProducts = ref(false);
    const products = ssrRef<ProductInterface[]>([]);
    const sortBy = ref<SortingModel>({ selected: '', options: [] });
    const pagination = ref<Pagination>({});
    const productContainerElement = ref<HTMLElement | null>(null);
    const aggregation = ref<Array<Aggregation>>([]);
    const searchKeyWord = ref<String>('');

    const {
      toggleFilterSidebar,
      changeToCategoryListView,
      changeToCategoryGridView,
      isCategoryGridView,
      isFilterSidebarOpen,
    } = useUiState();
    const {
      addItem: addItemToWishlistBase,
      isInWishlist,
      removeItem: removeItemFromWishlist,
    } = useWishlist();
    const { result, search } = useFacet();

    const { addItemToCart } = useAddToCart();

    // const { search: searchCategories, loading: categoriesLoad } = useCategorySearch();

    const addItemToWishlist = async (product: Product) => {
      await (isInWishlist({ product })
        ? removeItemFromWishlist({ product })
        : addItemToWishlistBase({ product }));
    };

    const { activeCategory } = useTraverseCategory();
    const activeCategoryName = computed(() => activeCategory.value?.name ?? '');

    const { fetch } = useFetch(async () => {
      aggregation.value = [];
      isShowProducts.value = true;
      const searchObj = { ...uiHelpers.getFacetsFromURL() };
      searchKeyWord.value = searchObj?.term || searchObj?.keyword || '';
      await search(searchObj);
      products.value = facetGetters.getProducts(result.value) ?? [];
      sortBy.value = facetGetters.getSortOptions(result.value);
      pagination.value = facetGetters.getPagination(result.value);
      aggregation.value = facetGetters.getAggregation(result.value);
    });

    const isPriceLoaded = ref(true);

    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      fetch();
    };

    const doChangeItemsPerPage = (itemsPerPage: number) => {
      uiHelpers.changeItemsPerPage(itemsPerPage, false);
      goToPage(0);
    };

    const onReloadProducts = () => {
      goToPage(0);
      productContainerElement.value.scrollIntoView();
    };
    console.log('search products lsit', products);

    return {
      isPriceLoaded,
      ...uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      pagination,
      products,
      sortBy,
      isShowProducts,
      activeCategoryName,
      routeData,
      doChangeItemsPerPage,
      productContainerElement,
      onReloadProducts,
      goToPage,
      aggregation,
      searchKeyWord,
    };
  },
  // head() {
  //   return getMetaInfo(this.categoryMeta);
  // },
});
